import React from 'react';

const AppLoading = () => {
  return (
    <div className="App-loading">Loading...</div>
  )
}

export default AppLoading;